<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateReviewPeriod"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full md:h-auto h-screen overflow-auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Add Performance Period</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <!-- Name -->
            <div class="text-sm">
              <label class="block pb-1">Name</label>
              <input
                v-model="info.Name"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <!-- Start Date -->
            <div class="text-sm">
              <label class="block pb-1">Start Date</label>
              <input
                v-model="info.StartDate"
                required
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <!-- End Date -->
            <div class="text-sm">
              <label class="block pb-1">End Date</label>
              <input
                v-model="info.EndDate"
                required
                type="date"
                :min="info.StartDate"
                :max="financialPeriodEndDate"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <!-- Objective Setting Period Start Date -->
            <!-- <div class="text-sm">
              <label class="block pb-1">Objective Setting Start Date</label>
              <input
                v-model="info.ObjectiveSettingStartDate"
                :min="info.StartDate"
                :max="info.EndDate"
                required
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div> -->

            <!-- Objective Setting Period Deadline -->
            <div class="text-sm">
              <label class="block pb-1">Objective Setting Deadline</label>
              <input
                v-model="info.ObjectiveDeadline"
                :min="info.ObjectiveSettingStartDate"
                :max="info.EndDate"
                required
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <!-- Review Period Start Date -->
            <!-- <div class="text-sm">
              <label class="block pb-1">Review Start Date</label>
              <input
                v-model="info.ReviewStartDate"
                :min="info.StartDate"
                :max="info.EndDate"
                required
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div> -->

            <!-- Review Period Deadline -->
            <div class="text-sm">
              <label class="block pb-1">Review Deadline</label>
              <input
                v-model="info.ReviewDeadline"
                :min="info.ReviewStartDate"
                :max="info.EndDate"
                required
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/components/loader/loader.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "CreateReviewPeriod",
  props: ["showCreateReviewPeriod", "reload"],
  components: { Loader },
  data() {
    return {
      info: {
        Name: null,
        StartDate: null,
        EndDate: null,
        ObjectiveSettingDeadline: null,
        ObjectiveDeadline: null,
        ObjectiveSettingStartDate: null,
        ReviewStartDate: null,
        ReviewDeadline: null,
      },
      financialPeriods: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .post(
          `${this.getOrganization}/performance/period/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        )
        .then((response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.$notify.success({
              title: "Success",
              message: response.data.StatusMessage,
            });
            this.reload();
          } else {
            this.$notify.error({
              title: "Failure",
              message: response.data.StatusMessage,
            });
          }
        });
    },
  },
  created() {},
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
